{
  "collapse": "Zwiń",
  "expand": "Rozwiń"
}
